// Shared infrastructure: env helpers.

const url = (import.meta.env.VITE_SUPABASE_URL ?? "").trim();
const anon = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? "").trim();

if (!url || !anon) {
  // Don't crash on missing env during build; warn so the developer
  // notices in the browser console.
  console.warn(
    "[env] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not set. " +
      "Copy .env.local.example to .env.local and fill the values.",
  );
}

export const env = {
  supabaseUrl: url || "https://invalid.supabase.co",
  supabaseAnonKey: anon || "invalid",
  isConfigured: Boolean(url) && Boolean(anon),
} as const;
